module.exports = __webpack_public_path__ + "img/station.850ede7b.webp";